"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextWrapper = exports.Text = exports.SliderItem = exports.SliderContainer = exports.Price = exports.PrevArrowEl = exports.NextArrowEl = exports.ImageWrapper = exports.Image = exports.Container = exports.Brand = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Arrow = _styledComponents.default.div`
  height: 40px;
  width: 40px;
  background: white;
  transition: 0.13s all;
  display: flex;
  box-sizing: border-box;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  position: absolute;
  transform: translate3d(0, -50%, 0);
  z-index: 1;
  cursor: pointer;

  img {
    max-width: 16px;
  }
`;
const NextArrowEl = (0, _styledComponents.default)(Arrow)`
  right: 20px;
`;
exports.NextArrowEl = NextArrowEl;
const PrevArrowEl = (0, _styledComponents.default)(Arrow)`
  left: 20px;

  img {
    transform: rotate(180deg);
  }
`;
exports.PrevArrowEl = PrevArrowEl;
const SliderItem = _styledComponents.default.div`
  position: relative;
  img {
    max-width: 100%;
  }
`;
exports.SliderItem = SliderItem;
const ImageWrapper = _styledComponents.default.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;
exports.ImageWrapper = ImageWrapper;
const Image = _styledComponents.default.img`
  max-width: 100%;
  transform-origin: center center;
`;
exports.Image = Image;
const TextWrapper = _styledComponents.default.div`
  margin-top: 8px;
`;
exports.TextWrapper = TextWrapper;
const Text = _styledComponents.default.p`
  margin: 0;
  font-family: 'univers-roman';
  font-size: 13px;
  align-self: start;

  @media (min-width: 768px) {
    font-size: 18px;
    max-width: 240px;
  }
`;
exports.Text = Text;
const Brand = (0, _styledComponents.default)(Text)`
  text-transform: uppercase;
`;
exports.Brand = Brand;
const Price = (0, _styledComponents.default)(Text)`
  margin-top: 4px;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'univers-bold';
`;
exports.Price = Price;
const Container = _styledComponents.default.div`
  ${(0, _layout.setContainer)({
  size: 'lg'
})}
`;
exports.Container = Container;
const SliderContainer = _styledComponents.default.div`
  position: relative;
  overflow: hidden;
  a {
    color: black;
    text-decoration: none;
  }

  .slick-list {
    width: calc(100% + 20px);
    @media (min-width: 768px) {
      width: calc(100% + 16px);
    }
  }

  .slick-slide {
    padding-right: 20px;

    @media (min-width: 768px) {
      padding-right: 16px;
    }
  }
`;
exports.SliderContainer = SliderContainer;
//# sourceMappingURL=styles.js.map